import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from "./authConfig";
import { AppEnvSetting } from './ts/common';
import APPSETTINGS from './settings.json';

const orgMappings = AppEnvSetting.orgs;

const orgUrlparams = new URLSearchParams(window.location.search);
let sisuEndpoint = orgMappings.default.sisu;
let orgId = "";
if(orgUrlparams.has("orgId")){
  orgId = orgUrlparams.get("orgId")!;
} else if (localStorage.getItem("orgId") !== null){
  orgId = localStorage.getItem("orgId")!;
} else {
  orgId = "default";
}

if(Object.keys(orgMappings).includes(orgId)){
  sisuEndpoint = orgMappings[orgId as keyof typeof orgMappings].sisu
}


let usedMSALConfig = {...msalConfig, auth: {...msalConfig.auth, authority: sisuEndpoint}};

const msalInstance = new PublicClientApplication(usedMSALConfig);

if (APPSETTINGS.msalOtherPortalClientId && (window.sessionStorage.getItem("msal.interaction.status") === APPSETTINGS.msalOtherPortalClientId)) {
  const cleanupMsalConfig = { ...msalConfig, auth: { ...msalConfig.auth, clientId: APPSETTINGS.msalOtherPortalClientId } }
  const cleanupMsalInstance = new PublicClientApplication(cleanupMsalConfig);
  cleanupMsalInstance.initialize().then(() => {
    return cleanupMsalInstance.handleRedirectPromise().catch((e) => {
      console.log("Error occurred during MSAL cleanup: ", e);
    });
  }).then(() => {
    ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>,
    )
  });
} else {
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>,
  )
}
